import script from "./SignatureInputComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureInputComponent.vue?vue&type=script&setup=true&lang=js"

import "./SignatureInputComponent.vue?vue&type=style&index=0&id=24c2e546&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24c2e546"]])

export default __exports__